const config = {
    //baseUrl: 'https://api.activate.smallhd.com/apis/',
    apiUrl: 'https://repairs.cs.inc:7010', // https://downloads.smallhd.com:4002, http://localhost:4002
    siteUrl: 'https://downloads.smallhd.com', //https://downloads.smallhd.com/ , http://localhost:3000
    downloadFirmwareUrl : 'https://downloads.smallhd.com/dev/backend-node-server/firmware/',//smallhd_OS3_firmware
    itemsimgUrl : 'https://cdn.shopify.com/s/files/1/0097/6004/7167/products/',
    productDetailUrl : 'https://smallhd.com/products/',
    downloadFirmwarePrefix : 'smallhd_OS_',
    gaTrackingId : 'UA-3948233-6'
};

export default config;
